<div class="stats-container">
  @if (isLoading()) {
    <div class="loader">
      <rds-progress-spinner></rds-progress-spinner>
    </div>
  }
  @let currentStats = stats();
  @if (currentStats !== null) {
    <div class="stat-card">
      <div class="card-header"></div>
      <div class="card-title">Total Bookings Today ({{ weekday }})</div>
      <div class="card-value">{{ currentStats.totalBookingsToday }}</div>
      <div
        class="card-change"
        [ngClass]="{
          positive: currentStats.bookingsChangePercentage >= 0,
          negative: currentStats.bookingsChangePercentage < 0,
        }">
        <div class="icon">
          @if (currentStats.bookingsChangePercentage >= 0) {
            <rds-icon icon="arrow_up" size="small"></rds-icon>
          } @else {
            <rds-icon icon="arrow_down" size="small"></rds-icon>
          }
          <div>
            {{
              (currentStats.bookingsChangePercentage | number: '1.2-2') + '%'
            }}
            (Change from Last {{ weekday }})
          </div>
        </div>
      </div>
    </div>
    <div class="stat-card">
      <div class="card-header"></div>
      <div class="card-title">Total Bookings This Month</div>
      <div class="card-value">
        {{ currentStats.totalBookingsThisMonth }}
      </div>
      <div
        class="card-change"
        [ngClass]="{
          positive: currentStats.bookingsChangePercentageThisMonth >= 0,
          negative: currentStats.bookingsChangePercentageThisMonth < 0,
        }">
        <div class="icon">
          @if (currentStats.bookingsChangePercentageThisMonth >= 0) {
            <rds-icon icon="arrow_up" size="small"></rds-icon>
          } @else {
            <rds-icon icon="arrow_down" size="small"></rds-icon>
          }
          <div>
            {{
              (currentStats.bookingsChangePercentageThisMonth
                | number: '1.2-2') + '%'
            }}
            (Change from Previous Month)
          </div>
        </div>
      </div>
    </div>
    <div class="stat-card">
      <div class="card-header"></div>
      <div class="card-title">Booking Average Duration this Month</div>
      <div class="card-value">
        {{ formatDuration(currentStats.averageDurationThisMonth) }}
      </div>
      <div
        class="card-change"
        [ngClass]="{
          positive: currentStats.averageDurationChange >= 0,
          negative: currentStats.averageDurationChange < 0,
        }">
        <div class="icon">
          @if (currentStats.averageDurationChange >= 0) {
            <rds-icon icon="arrow_up" size="small"></rds-icon>
          } @else {
            <rds-icon icon="arrow_down" size="small"></rds-icon>
          }
          <div>
            {{ (currentStats.averageDurationChange | number: '1.2-2') + '%' }}
            (Change from Previous Month)
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="no-data">
      <p class="ui-label-l-bold">Stats not available</p>
    </div>
  }
</div>
